import { render } from "./PageView.vue?vue&type=template&id=108fad9e"
import script from "./PageView.vue?vue&type=script&lang=js"
export * from "./PageView.vue?vue&type=script&lang=js"

import "./PageView.vue?vue&type=style&index=0&id=108fad9e&lang=scss"

import exportComponent from "/home/runner/work/PEP/PEP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__